import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    byUser: {
        url: `${customerApi}/api/customer_distribution/by_user`,
        type: 'GET',
    },
    byChannel: {
        url: `${customerApi}/api/customer_distribution/by_channel`,
        type: 'GET',
    },
}
